import { render } from "./NotFound.vue?vue&type=template&id=5e0c88fb"
const script = {}
script.render = render

export default script